import { useContext } from "react";
import { BiSolidCheckCircle } from "react-icons/bi";
import {FaTrash} from 'react-icons/fa6';
import { AppContext } from "../../context/AppContext";
import { taskListActions } from "../../context/reducer";
import { BsExclamationTriangle } from "react-icons/bs";

const Task = (props) => {
    const {
        taskIndex,
        title,
        endTime,
        startTime,
        toastProps, 
        isActive,
        isArchived,
        description,
        isCompleted,
        setToastOpen, 
        setToastProps,
        noDataAvailable=false
    } = props;

    const {
        state: {taskList},
        dispatch
    } = useContext(AppContext);

    const taskHandler = (key) => {
        let updateList = [...taskList].map((list,idx) => (idx === taskIndex) ? {...list, [key]: true, isActive: false} : list); 
        
        dispatch({
            type: taskListActions.UPDATE_TASKLIST, 
            payload: updateList
        });

        setToastProps({
            ...toastProps, 
            message: key === 'isArchived' 
                ? 'Task is archived!' 
                : 'Task is completed!', 
            variant: key === 'isArchived' 
            ? 'error' 
            : 'info'
        })
        setToastOpen(true)
    }


    if(noDataAvailable){
        return (
            <div className="task-wrapper">
                <h2 className="text-center mx-auto py-4 flex-direction-column">
                    <BsExclamationTriangle className="text-[42px] mx-auto mb-2" />
                    <span className="text-md font-bold">No Task Available</span></h2>
            </div>
        );
    }
    return (
        <div className={`task-wrapper 
            ${isCompleted ? 'bg-blue-100 cursor-not-allowed' : ''} 
            ${isArchived ? 'bg-red-100 cursor-not-allowed' : ''} 
            ${isActive ? 'bg-white' : ''}
        `}>
            <div className="task-wrapper-content">
                <h4 className={`tracking-[2px]`}>{title}</h4>
                <p>{description}</p>
                <p className="text-sm">Today: <span className="font-bold text-gray-600">{startTime} - {endTime}</span></p>
            </div>
            <div className="task-wrapper-footer">
                <button
                    onClick={() => taskHandler('isArchived')}
                    className={`${isCompleted || isArchived ? 'text-gray-400  bg-gray-100 disabled hover:shadow-none' : 'bg-red-100 text-red-600'} text-[12px] uppercase font-[700]  hover:shadow-md outline-none rounded-[6px] py-[6px] px-4 flex items-center gap-2`}>
                        <FaTrash /> Archive
                </button>
                <button 
                    onClick={() => taskHandler('isCompleted')}
                    className={`${isArchived || isCompleted ? 'text-gray-400 bg-gray-100 disabled hover:shadow-none' : 'bg-blue-100 text-blue-600'} text-[12px] uppercase font-[700] hover:shadow-md outline-none rounded-[6px] py-[6px] px-4 flex items-center gap-2`}>
                        <BiSolidCheckCircle /> Complete
                </button>
            </div>
        </div>
    )
}
export default Task;